<template>
     <div class="task-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="My Tasks" />
          <b-fom>
             <template>
                 <b-calendar 
                    v-model="value"
                    :date-info-fn="dateClass"
                    :date-disabled-fn="dateDisabled"
                    @input="[loadTasks(),loadTasksMonths()]"
                    block 
                    locale="en-US">
                 </b-calendar>
            </template>
          </b-fom>
          <br>
          <b-row>   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                hover 
                 head-variant="dark" 
                :items="tasks" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.finished_task"
                        title = "Finished" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxFinisheditem(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button> 
                </template>    
         </b-table> 
          </transition>

    </b-row>
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'TaskSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                value: '',
                ret: [],
                search: '',
                task: {},
                taskshareds:[],
                tasks: [],
                task_months: [],
                start_date: null,
                end_date: null,
                isBusy: false,
                showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
               { key: 'description_type_task', label: 'Type', sortable: true,variant: 'light' },
                { key: 'description_task', label: 'Description', sortable: true,variant: 'light' },
                 { key: 'task_date',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('DD-MM-YYYY') : '',variant: 'light'
                },
                { key: 'start_date_task',label: 'Start',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'end_date_task',label: 'End',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).utcOffset("-03:00").format('HH:mm') : '',variant: 'light'
                },
                { key: 'scheduled_task', label: 'Scheduled', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'}, 
                { key: 'finished_task', label: 'Finished', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},                              
                { key: 'actions', label: 'Action',variant: 'light' },

                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
              async showMsgBoxFinisheditem(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to finished the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.finished(item)
                    }
                })
            },
            loadTasks(){

                this.start_date = moment(this.value)
                    .format('YYYY-MM-DD')
                this.end_date = moment(this.value)
                    .format('YYYY-MM-DD')

                const url = `${baseApiUrl}/tasksbyuser/${this.user.id}?start_date=${this.start_date}&end_date=${this.end_date}`
                axios(url).then(res =>{
                     this.tasks = res.data
                      this.isBusy = false
                })

            },
            loadTasksMonths(){


                const url = `${baseApiUrl}/tasksbyuser/${this.user.id}?start_date=${moment(this.value)
                    .startOf('month')
                    .format('YYYY-MM-DD')}&end_date=${moment(this.value)
                    .endOf('month')
                    .format('YYYY-MM-DD')}`
                axios(url).then(res =>{
                     this.task_months = res.data
                      this.isBusy = false
                })

            },
            async save() {

                const method = this.task.id ? 'put' : 'post'
                const id = this.task.id ? `/${this.task.id}` : ''

               
                this.task.user_id_task = this.user.id
                this.task.company_id_task = this.compan.id
                

                await axios[method](`${baseApiUrl}/tasks${id}`, this.task)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            loadUsers() {
                const url = `${baseApiUrl}/usersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.users = res.data.map(type => {
                        return { value: type.id, text: type.name }
                    })
                })
            },
            dateDisabled(ymd, date) {
                const weekday = date.getDay()
               // const day = date.getDate()
                return weekday === 0 
                //|| weekday === 6 || day === 13
            },
             dateClass(ymd, date) {
                const day = date.getDate()
                 this.ret = []
                 this.task_months.map( (row)=>{
                    this.ret.push(parseInt(moment(row.task_date).format('DD')))
                })
                return this.ret.includes(day) ? 'table-info' : ''
              
            },
            setToday() {
                const now = new Date()
                this.value = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            },
            async finished(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/finishedtasks/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTasks()

                        })
                        .catch(showError)

           },
                

        },
        mounted(){
            this.loadTasks()
            this.setToday()
            this.showTable = true
        }
}
</script>

<style>


    .task-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .task-search button{
        font-size: 0.75rem;
    }

     .task-search select{
        font-size: 0.75rem;
    }

    .task-search input{
        font-size: 0.75rem;
    }


    .task-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    #modalShared {
        font-size: 0.75rem;
    }

    #modalShared button{
        font-size: 0.75rem;
    }

       #modalShared select{
        font-size: 0.75rem;
    }

     #modalShared input{
        font-size: 0.75rem;
    }

      #modalShared label{
        font-size: 0.75rem;
        color: black;
    }

 

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
